// 各 type に対応する「代表天体グリフ」と「主軸の組み合わせ」
// StarChart の中心グリフ + 周辺軸星 を描画するためのデータ。
//
// glyph: 中心に置く Unicode 占星術記号
//   ☉ Sun, ☽ Moon, ☿ Mercury, ♀ Venus, ♂ Mars,
//   ♃ Jupiter, ♄ Saturn, ♅ Uranus, ♆ Neptune,
//   ⛤ Pentagram (Polaris用), ✦ Star (汎用)
//
// primaryAxes: 軸星の強調順序。最初の軸が最も強く、後ろほど弱い。
//   軸キー: activation / judgment / choice / resonance / awareness

const TYPE_MOTIFS = {
  // Activation 起動軸 (6)
  ACPU: { glyph: '♂', primaryAxes: ['activation', 'choice']    },  // マーズ・戦士
  ACBL: { glyph: '☉', primaryAxes: ['activation', 'awareness'] },  // ソーラー・太陽
  ACCV: { glyph: '♂', primaryAxes: ['activation', 'choice']    },  // フレア・噴き上がる焔
  ACJG: { glyph: '♄', primaryAxes: ['activation', 'judgment']  },  // パルサー・拍動
  ACRN: { glyph: '☉', primaryAxes: ['activation', 'resonance'] },  // レディエント・広がる光
  ACCP: { glyph: '♄', primaryAxes: ['activation', 'judgment']  },  // フォーカス・凝視

  // Judgment 判断軸 (4)
  JDPU: { glyph: '☿', primaryAxes: ['judgment', 'activation']  },  // マーキュリー・言葉の運び手
  JDRA: { glyph: '☿', primaryAxes: ['judgment', 'awareness']   },  // クリスタル・透徹の洞察
  JDCP: { glyph: '♆', primaryAxes: ['judgment', 'awareness']   },  // コスモス・世界の編み手
  JDCV: { glyph: '♅', primaryAxes: ['judgment', 'choice']      },  // ウラニア・知識の織り手

  // Choice 選択軸 (5)
  CHRA: { glyph: '♀', primaryAxes: ['choice', 'resonance']     },  // ヴィーナス・美の選び手
  CHJA: { glyph: '☽', primaryAxes: ['choice', 'judgment']      },  // ディアナ・月光の狩人
  CHAT: { glyph: '♅', primaryAxes: ['choice', 'activation']    },  // ユーレカ・閃光の発見
  CHJG: { glyph: '♃', primaryAxes: ['choice', 'judgment']      },  // アテナ・思慮の守護
  CHJC: { glyph: '☉', primaryAxes: ['choice', 'judgment']      },  // ヘリオス・選びの灯台

  // Resonance 共鳴軸 (4)
  RSAW: { glyph: '☽', primaryAxes: ['resonance', 'awareness']  },  // ルナ・月の癒し手
  RSCV: { glyph: '♀', primaryAxes: ['resonance', 'choice']     },  // ミューズ・啓示の呼び水
  RSAB: { glyph: '☿', primaryAxes: ['resonance', 'activation'] },  // ジェミニ・縒り合わせる絆
  RSBL: { glyph: '♀', primaryAxes: ['resonance', 'judgment']   },  // リブラ・響きの調停

  // Awareness 自覚軸 (2)
  AWAB: { glyph: '♃', primaryAxes: ['awareness', 'judgment']   },  // パノラマ・俯瞰の人
  AWRN: { glyph: '☽', primaryAxes: ['awareness', 'resonance']  },  // カシオペア・夜目の感知

  // Integration 統合 (3) — 主軸を 1 つに絞れないので 5 軸均等
  BLNC: { glyph: '⛤', primaryAxes: ['activation', 'judgment', 'choice', 'resonance', 'awareness'] },  // ポラリス・北極星
  CMPL: { glyph: '✦', primaryAxes: ['activation', 'judgment', 'choice', 'resonance', 'awareness'] },  // コーラス・重奏の織り手
  ADPT: { glyph: '☽', primaryAxes: ['activation', 'judgment', 'choice', 'resonance', 'awareness'] },  // カメレオン・月相
};

const DEFAULT_MOTIF = { glyph: '✦', primaryAxes: [] };

export const getMotif = (code) => TYPE_MOTIFS[code] || DEFAULT_MOTIF;

export default TYPE_MOTIFS;
